<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (loaded) {
      <tidy-card>
        <form [formGroup]="form">
          <tidy-row style="position: relative;">
            <tidy-auto-complete
              [label]="'To-Do'"
              formControlName="title"
              [options]="toDoAutoComplete"
              [form]="form.controls.title"
              [icon]="'assets/svg/list.svg'"
              [isToSearchBetweenOptions]="true"
              [submitted]="submitted"
              [errorMessage]="'Please enter the name of the to-do'"
              style="width: calc(100% - 135px);" />
            <div style="position: absolute; right: 0; top: 0; bottom: 0; width: 125px;">
              <tidy-select
                [icon]="'assets/svg/time.svg'"
                [label]="'Est. Time'"
                [form]="form.controls.time"
                formControlName="time"
                [items]="estimatedTimes"
                style="height: 100%;" />
            </div>
          </tidy-row>
          <tidy-row>
            <tidy-textarea
              [label]="'Details (Optional)'"
              formControlName="note"
              [form]="form.controls.note"
              [icon]="'assets/svg/information-circle.svg'" />
          </tidy-row>
          <tidy-row [alignLastItemRight]="true">
            <tidy-checkbox
              [(checked)]="important"
              [items]="[{viewValue: 'Mark as Important', value: false}]"
              [initValue]="important" />
            <tidy-text
              class="link"
              [body]="'Add Photos'"
              (action)="takePhotos()" />
          </tidy-row>
          <photo-caption
            [type]="'room'"
            [photoUrls]="photoUrls" />
          @if (!toDo) {
            <tidy-row class="extra-top-padding">
              <tidy-text
                [body]="'Add checklist item to:'" />
            </tidy-row>
            @for (room of rooms; track room; let even = $even; let i = $index) {
              @if (even) {
                <tidy-two-column-row>
                  <tidy-checkbox
                    item-left
                    [items]="[room]"
                    [initValue]="room?.value === preSelectedRoom"
                    (checkedChange)="selectRoom(room?.value)" />
                  @if (rooms[i+1] !== undefined) {
                    <tidy-checkbox
                      item-right
                      [items]="[rooms[i+1]]"
                      [initValue]="rooms[i+1]?.value === preSelectedRoom"
                      (checkedChange)="selectRoom(rooms[i+1]?.value)" />
                  }
                </tidy-two-column-row>
              }
            }
            @if (roomError) {
              <tidy-row>
                <tidy-error-message
                  [text]="'Please select cards to add checklist item.'" />
              </tidy-row>
            }
          }
          @if (hasInventoryField) {
            <tidy-row [alignLastItemRight]="true" class="extra-top-padding extra-bottom-padding">
              <tidy-text
                [header]="'Take Inventory'" />
              <ion-icon
                name="trash-outline"
                class="link"
                style="font-size: 20px; cursor: pointer;"
                (click)="removeInventoryField()" />
            </tidy-row>
            <tidy-row>
              <tidy-auto-complete
                [label]="'Item Name'"
                [icon]="'assets/svg/information-circle.svg'"
                [options]="itemsAutoComplete"
                [form]="form.controls.itemName"
                formControlName="itemName"
                [submitted]="false"
                (action)="selectItem($event)" />
            </tidy-row>
            <tidy-row>
              <tidy-select
                [label]="'Item Category'"
                [icon]="'assets/svg/list.svg'"
                [items]="categoryItems"
                [multiple]="false"
                [form]="form.get('itemCategory')"
                [submitted]="submitted"
                formControlName="itemCategory" />
            </tidy-row>
            <tidy-row [align]="'center'">
              <tidy-text
                [smallHelper]="'This will update the restocking item that exactly matches this name at the property. If nothing matches, it will be added to restocking.'" />
            </tidy-row>
          }
          @if (!hasInventoryField && !isAddingCustomFields) {
            <tidy-row [align]="'center'" class="extra-top-padding">
              <tidy-text
                [actionBody]="'+ Collect Information'"
                class="link"
                (action)="expandFields()"
                style="margin-right: 20px;" />
                <tidy-text
                  [actionBody]="'+ Take Inventory'"
                  class="link"
                  (action)="addInventoryField()" />
            </tidy-row>
          }
        </form>
      @if (isAddingCustomFields) {
        @for (customForm of customFieldForm; track customForm; let i = $index) {
            <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
              <tidy-text
                [header]="'Custom Field'" />
              <div style="display: flex; align-items: center;">
                <tidy-checkbox
                  [items]="[{viewValue: 'Required', value: true}]"
                  (click)="selectRequired(customForm, customForm.form.value.required)"
                  [initValue]="customForm.form.value.required"
                  style="padding-right: 20px;" />
                <ion-icon
                  name="trash-outline"
                  class="link"
                  style="font-size: 20px; cursor: pointer;"
                  (click)="removeField(i)" />
              </div>
            </tidy-row>
            <form [formGroup]="customFieldForm[i].form">
              <tidy-row class="extra-bottom-padding">
                <tidy-input
                  [label]="('Field Label (what should the pro do?)' | translate) + (customForm?.maxLength ? '*' : '')"
                  formControlName="label"
                  [form]="customForm.form.controls.label"
                  [icon]="'assets/svg/create.svg'"
                  [submitted]="submitted"
                  [customMask]="customForm?.maxLength ? { maxLenghth: customForm.maxLength } : null"
                  [errorMessage]="'Please enter a label.'" />
              </tidy-row>
              @if (customForm?.maxLength) {
                <tidy-row class="extra-bottom-padding" style="margin-top: -15px">
                  <tidy-text
                    [smallHelper]="'*40 character max label length for this field type'" />
                </tidy-row>
              }
              <tidy-row>
                <tidy-select
                  [icon]="'assets/svg/list.svg'"
                  [label]="'Field Type'"
                  [form]="customForm.form.controls.type"
                  formControlName="type"
                  [items]="customFieldTypeItems"
                  (optionChange)="selectFieldType($event, i)"
                  [submitted]="submitted"
                  [errorMessage]="'Please select a field type.'" />
              </tidy-row>
              @if (customForm.numberOfRequiredOptions > 0) {
                <tidy-row [alignLastItemRight]="true">
                  <tidy-text
                    [header]="'Options'"
                    style="margin-right: 5px" />
                  <tidy-text
                    [actionBody]="'Add Option'"
                    class="link"
                    (action)="addOption(i)" />
                </tidy-row>
                @for (option of customForm.options; track option; let index = $index) {
                  <tidy-row>
                    <tidy-text
                      [body]="'Option'" /><span>&nbsp;</span>
                    <tidy-text
                      [body]="((index | translate) + (1 | translate))" /><span>&nbsp;</span>
                    <tidy-text
                      [actionBody]="'X'"
                      class="link"
                      (action)="removeOption(i, index)" />
                  </tidy-row>
                  <tidy-row>
                    <form [formGroup]="customFieldForm[i].options[index]">
                      <tidy-input
                        [label]="('Option ' | translate) + ((index | translate) + (1 | translate)) + (' Label' | translate)"
                        formControlName="option"
                        [form]="customFieldForm[i].options[index].controls.option"
                        [icon]="'assets/svg/create.svg'"
                        [submitted]="submitted"
                        [errorMessage]="'Please enter a label.'" />
                    </form>
                  </tidy-row>
                  @if (customForm.options[index].hasCommaError) {
                    <tidy-row style="margin-top: -5px">
                      <tidy-error-message
                        [text]="'Please remove any commas from the option label.'" />
                    </tidy-row>
                  }
                }
                @if (customForm.options.length == 0) {
                  <tidy-row class="extra-bottom-padding">
                    <tidy-text
                      [helper]="'None Added - Add at Least'" /><span>&nbsp;</span>
                    <tidy-text
                      [helper]="customForm.numberOfRequiredOptions" />
                  </tidy-row>
                }
                @if (submitted && (customForm.options.length < customForm.numberOfRequiredOptions)) {
                  <tidy-row class="extra-bottom-padding">
                    <tidy-error-message
                      [text]="('Please add at least ' | translate) + customForm.numberOfRequiredOptions + (' option' | translate) + (customForm.numberOfRequiredOptions == 1 ? '' : ('s' | translate))" />
                  </tidy-row>
                }
              }
            </form>
            <tidy-row class="extra-top-padding extra-bottom-padding">
              <tidy-divider />
            </tidy-row>
        }
        @if (isAddingCustomFields) {
          <tidy-row [align]="'center'" class="extra-bottom-padding">
            <tidy-text
              [actionBody]="'+ Add Field'"
              class="link"
              (action)="addCustomField()" />
          </tidy-row>
        }
      }
      @if (hasInventoryField && !isAddingCustomFields) {
        <tidy-row [align]="'center'" class="extra-top-padding extra-bottom-padding">
          <tidy-text
            [actionBody]="'+ Collect Information'"
            class="link"
            (action)="expandFields()" />
        </tidy-row>
      }
      @if (isAddingCustomFields && !hasInventoryField) {
        <tidy-row [align]="'center'" class="extra-top-padding extra-bottom-padding">
          <tidy-text
            [actionBody]="'+ Take Inventory'"
            class="link"
            (action)="addInventoryField()" />
        </tidy-row>
      }
      </tidy-card>
      @if (errorMessage?.length) {
        <tidy-error-message
          [text]="errorMessage" />
      }
      <tidy-button
        [text]="buttonText"
        [action]="boundAddToDo"
        class="primary" />
      @if (toDo) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'Delete To-Do'"
            (action)="deleteToDo()"
            class="link red" />
        </tidy-row>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
